import { IAuthRoleContext } from "./IAuthRoleContext";

import { createContext } from "react";

/**
 * This constant provides access to user authority roles within the current context.
 * The authority roles depend on e.g. the selected contract.
 */
export const AuthRoleContext = createContext<IAuthRoleContext>(null!);
